import { BusinessProtectionProductsInput } from '../generated/resolvers'
import request from '../requesters/default'

export const saveBusinessProtectionProducts = async (body: BusinessProtectionProductsInput) => {
  const response = await request.post('/protection_solution', body)

  return response?.data?.protection_products
}
